export default "__VITE_ASSET__B_h19_vd__"